import React from 'react';
import { NavLinkTab } from 'Shared';
import { createUseStyles } from 'react-jss';
import { Heading } from 'evergreen-ui';
import { settingsStyles } from '../useStyles';

const useStyles = createUseStyles({
  settings_sidebar: {
    display: 'grid',
    gridAutoRows: 'max-content',
    overflowY: 'auto',
    borderRight: '1px solid #eee',
    boxShadow: '0 6px 7px 0 rgba(0, 0, 0, .25)',
    position: 'relative',
    minWidth: '300px',
    // box-sizing: border-box;
  },
  settings_sidebar_group: {
    display: 'grid',
    gridAutoRows: 'max-content',
    gridRowGap: '.2rem',
    padding: '1rem',
  },
  settings_sidebar_tab: {
    ...settingsStyles.settings_tab,
  },
});
export const SettingsSidebar = React.memo(({ groups = [] }) => {
  const classes = useStyles();
  return (
    <div className={classes.settings_sidebar}>
      {
        groups.length > 0
          ? (
            <>
              {
                React.Children.toArray(groups.map(({ heading, navlinks }) => (
                  <>
                    <div key={heading} className={classes.settings_sidebar_group}>
                      <Heading size={500} marginBottom="1rem">{heading}</Heading>
                      {
                        Object.entries(navlinks).map(([to, text]) => (
                          <NavLinkTab key={to} to={to} className={classes.settings_sidebar_tab}>{text}</NavLinkTab>
                        ))
                      }
                    </div>
                  </>
                )))
              }
            </>
          )
          : <div> нет groups </div>
      }
    </div>
  );
});
SettingsSidebar.displayName = 'SettingsSidebar';
